const statusesMap = new Map([
  ['not_operational', 'No operativo'],
  ['operational', 'Operativo'],
  ['to_identify', 'Por identificar'],
  ['no_device', 'Sin dispositivo']
])

export {statusesMap}



// WEBPACK FOOTER //
// ./src/utils/statuses.js